import Mp3Encoder from './mp3-encoder.js'
import { convertTimeMMSS } from './utils.js'

export default class {
    constructor (options = {}) {
        this.beforeRecording = options.beforeRecording
        this.pauseRecording  = options.pauseRecording
        this.afterRecording  = options.afterRecording
        this.micFailed       = options.micFailed
        this.format          = options.format

        this.encoderOptions = {
            bitRate    : options.bitRate,
            sampleRate : options.sampleRate
        }

        this.bufferSize = 4096
        this.records    = []

        this.countdownStartet       = false
        this.isPause                = false
        this.isRecording            = false
        this.initUserMedia          = false

        this.duration = -3
        this.countdownEnded = false
        this.countdownTime = -3
        this.countdownDuration = 0

        this.input = null
        this.analyser = null
        this.stream = null
        this.context = null
        this.processor = null
        this.gainNode = null
        this.currentVolume = 0
    }

    start () {
        this.countdownStartet       = false
        this.initUserMedia          = true
        this.countdownEnded         = false
        this.duration               = this.countdownTime

        const constraints = {
            audio: {
                echoCancellation: true,
                noiseSuppression: true,
                autoGainControl: true,
                channelCount: 1
            }
        }

        this.beforeRecording && this.beforeRecording('start recording')

        navigator.mediaDevices
            .getUserMedia(constraints)
            .then((stream) => {
                this.context = new(window.AudioContext || window.webkitAudioContext)()
                this.encoderOptions.sampleRate = this.context.sampleRate

                if (!this.lameEncoder) {
                    this.lameEncoder = new Mp3Encoder(this.encoderOptions)
                }

                this.input = this.context.createMediaStreamSource(stream);

                this.analyser = this.context.createAnalyser();
                const pcmData = new Float32Array(this.analyser.fftSize);

                this.gainNode = this.context.createGain ? this.context.createGain() : this.context.createGainNode();
                this.gainNode.gain.value = 1;

                this.processor = this.context.createScriptProcessor(this.bufferSize, 1, 1);

                this.input.connect(this.gainNode);
                this.input.connect(this.analyser);
                this.gainNode.connect(this.processor);

                this.processor.onaudioprocess = (ev) => {
                    if (!this.countdownStartet) {
                        this.startCountdown();
                    }

                    if (this.countdownEnded !== false){
                        this.initUserMedia = false;

                        this.analyser.getFloatTimeDomainData(pcmData);
                        let sumSquares = 0.0;
                        for (const amplitude of pcmData) { sumSquares += amplitude*amplitude; }
                        this.currentVolume = Math.sqrt(sumSquares / pcmData.length);

                        this.duration = this.context.currentTime - this.countdownEnded;
                        if (this.duration > 0.5) {
                            const sample = ev.inputBuffer.getChannelData(0)
                            this.lameEncoder.encode(sample)
                        }
                    }
                }
                this.processor.connect(this.context.destination);

                this.stop = () => {
                    this.processor.disconnect();
                    this.context.close();
                    if (this.input) {
                        this.input.disconnect();
                    }
                    this.input = null;
                    this.duration = this.duration;

                    let tracks = stream.getTracks();
                    tracks.forEach((track) => track.stop());

                    for (let i = 0; i < tracks.length; i++) {
                        stream.removeTrack(tracks[i]);
                    }

                    // stream.disconnect();

                    delete this.input;

                    let record = null
                    record = this.lameEncoder.finish()
                    record.duration = convertTimeMMSS(this.duration)
                    this.records.push(record)

                    this.duration  = 0
                    this.isPause        = false
                    this.isRecording    = false

                    this.afterRecording && this.afterRecording(record)
                };
            })
            .catch(this._micError.bind(this))

        this.isPause     = false
        this.isRecording = true
    }

    recordList () {
        return this.records
    }

    lastRecord () {
        return this.records.slice(-1).pop()
    }

    _micError (error) {
        this.micFailed && this.micFailed(error)
    }

    startCountdown () {
        this.countdownStartet = true;
        this.initUserMedia = false;

        // count down three seconds before the real recording starts
        var countdown = setInterval(() => {
            // if countdown is 0, start recording
            this.duration++;

            if (this.duration > -1){
                clearInterval(countdown);
                this.countdownEnded = this.context.currentTime;
            }
        }, 1000);
    }

    getAverageVolume(array) {
        var values = 0;
        var average;

        var length = array.length;

        // get all the frequency amplitudes
        for (var i = 0; i < length; i++) {
            values += array[i];
        }

        average = values / length;
        return average;
    }
}
